const SCHOOL_URL =
  'https://docs.google.com/presentation/d/1201f_s-DBbPcakvPGVMOq7PRk22EgUH55v299kl7tJU/embed?slide=id.g365a5ccdab8_0_4849/embed?slide=id.g365a5ccdab8_0_4849'

const SchoolIFrame = () => <iframe title="School" height="100%" width="100%" src={SCHOOL_URL} />

export default SchoolIFrame
